import React from 'react';
import { useLocation } from 'react-router-dom';
import { redirectTo } from '@99designs/routing';
import { ViewerConsumer } from './ViewerContext';
import { ViewerContext_UserFragment } from './ViewerContext.generated';

export function designerOnly<T>(
    redirect_url: string,
    Component: React.ComponentType<T>,
    certifiedOnly?: boolean
): React.FC<T> {
    const isDesigner = (viewer: ViewerContext_UserFragment): boolean => {
        return certifiedOnly ? viewer.isDesigner && viewer.isCertifiedDesigner : viewer.isDesigner;
    };

    return function DesignerOnly(props: T) {
        const location = useLocation();
        return (
            <ViewerConsumer>
                {(viewer) => {
                    if (!viewer) {
                        // If the url already contains params these should persist through login.
                        const fromUrl = `${location.pathname}${location.search}`;

                        redirectTo('/login', [{ key: 'from', value: fromUrl }]);

                        return null;
                    } else if (!isDesigner(viewer) && !viewer.isAdmin) {
                        redirectTo(redirect_url);

                        return null;
                    }
                    // TODO: Type 'T' is not assignable to type 'IntrinsicAttributes & T & { children?: ReactNode; }'.
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    return <Component {...(props as T)} />;
                }}
            </ViewerConsumer>
        );
    };
}
